//# sourceMappingURL=minus.mjs.map
/// <reference types="./minus.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function minus() {
  return $svg.square(
    24,
    "<path d=\"M5 11.1147H19V13.1147H5V11.1147Z\" fill=\"currentColor\"/>",
  );
}
